import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-md sticky top-0 z-50" data-id="element-198">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-199">
        <Link to="/" className="flex items-center" data-id="element-200">
          <span className="text-blue-600 font-bold text-2xl" data-id="element-201">SafeCircuit</span>
          <span className="text-gray-700 font-semibold ml-1" data-id="element-202">EICR</span>
        </Link>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-203">
          <Link to="/" className="text-gray-700 hover:text-blue-600 font-medium" data-id="element-204">
            Home
          </Link>
          <a href="#services" className="text-gray-700 hover:text-blue-600 font-medium" data-id="element-205">
            Services
          </a>
          <a href="#about" className="text-gray-700 hover:text-blue-600 font-medium" data-id="element-206">
            About
          </a>
          <a href="#pricing" className="text-gray-700 hover:text-blue-600 font-medium" data-id="element-207">
            Pricing
          </a>
          <a href="#faq" className="text-gray-700 hover:text-blue-600 font-medium" data-id="element-208">
            FAQ
          </a>
          <a href="#contact" className="text-gray-700 hover:text-blue-600 font-medium" data-id="element-209">
            Contact
          </a>
        </nav>
        <div className="hidden md:flex items-center" data-id="element-210">
          <a href="tel:+441234567890" className="flex items-center text-blue-600 font-semibold" data-id="element-211">
            <PhoneIcon className="w-5 h-5 mr-2" data-id="element-212" />
            <span data-id="element-213">01234 567890</span>
          </a>
          <a href="#contact" className="ml-6 bg-blue-600 text-white px-5 py-2 rounded-md hover:bg-blue-700 transition-colors" data-id="element-214">
            Get a Quote
          </a>
        </div>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-gray-700" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-215">
          {isMenuOpen ? <XIcon size={24} data-id="element-216" /> : <MenuIcon size={24} data-id="element-217" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white border-t" data-id="element-218">
          <div className="container mx-auto px-4 py-3 flex flex-col" data-id="element-219">
            <Link to="/" className="py-3 text-gray-700 hover:text-blue-600 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-220">
              Home
            </Link>
            <a href="#services" className="py-3 text-gray-700 hover:text-blue-600 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-221">
              Services
            </a>
            <a href="#about" className="py-3 text-gray-700 hover:text-blue-600 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-222">
              About
            </a>
            <a href="#pricing" className="py-3 text-gray-700 hover:text-blue-600 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-223">
              Pricing
            </a>
            <a href="#faq" className="py-3 text-gray-700 hover:text-blue-600 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-224">
              FAQ
            </a>
            <a href="#contact" className="py-3 text-gray-700 hover:text-blue-600 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-225">
              Contact
            </a>
            <div className="mt-3 pt-3 border-t flex flex-col" data-id="element-226">
              <a href="tel:+441234567890" className="flex items-center text-blue-600 font-semibold py-3" data-id="element-227">
                <PhoneIcon className="w-5 h-5 mr-2" data-id="element-228" />
                <span data-id="element-229">01234 567890</span>
              </a>
              <a href="#contact" className="mt-3 bg-blue-600 text-white px-5 py-2 rounded-md text-center hover:bg-blue-700 transition-colors" data-id="element-230">
                Get a Quote
              </a>
            </div>
          </div>
        </div>}
    </header>;
};
export default Header;